import { create } from 'zustand';
import { getDealStages } from '../services/api';

interface DealStagesState {
  dealStages: Record<string, string>;
  dealStagesList: string[];
  loading: boolean;
  error: string | null;
  fetchDealStages: (accessToken: string) => Promise<void>;
}

export const useDealStagesStore = create<DealStagesState>((set) => ({
  dealStages: {},
  dealStagesList: [],
  loading: true,
  error: null,

  fetchDealStages: async (accessToken: string) => {
    try {
      const response = await getDealStages(accessToken);
      const stages: Record<string, string> = {};
      const dealStagesList: string[] = [];
      
      response.stages.forEach((stage: any) => {
        stages[stage.id] = stage.label;
        dealStagesList.push(stage.id);
      });

      set({ dealStages: stages, dealStagesList, loading: false });
    } catch (err: any) {
      set({ error: err.message, loading: false });
    }
  }
})); 
